/* global $:false */

import 'modernizr.js'

export default class CommonLotShowAccordionTab {
  static init () {
    Array.from($('.js-common-lot-show-accordion-tab')).map((el) =>
      new CommonLotShowAccordionTab(el))
  }

  constructor (el) {
    this.el = $(el)
    this.findElements()
    this.readDataAttributes()
    this.setupBindings()
    this.recallTab()
  }

  findElements () {
    this.foldout = this.el.next()
  }

  readDataAttributes () {
    this.cacheKey = this.el.data('cache-key')
  }

  setupBindings () {
    this.el.click(event => this.toggle(event))
  }

  toggle (event) {
    if (event != null) {
      event.preventDefault()
    }
    if (this.isOpen()) { this.close() } else { this.open() }
  }

  open () {
    this.el.addClass('c-common-lot-show-accordion-tab--open')
    this.foldout.show()
    this.rememberTab()
  }

  close () {
    this.el.removeClass('c-common-lot-show-accordion-tab--open')
    this.foldout.hide()
    this.rememberTab()
  }

  isOpen () {
    return this.foldout.is(':visible')
  }

  rememberTab () {
    if (!window.Modernizr.localstorage) { return }
    if (!this.cacheKey) { return }
    if (this.isOpen()) {
      window.localStorage.setItem(this.cacheKey, 'open')
    } else {
      window.localStorage.setItem(this.cacheKey, 'closed')
    }
  }

  recallTab () {
    if (!window.Modernizr.localstorage) { return }
    if (!this.cacheKey) { return }
    const desiredState = window.localStorage.getItem(this.cacheKey)
    if (desiredState === 'open') { this.open() }
    if (desiredState === 'closed') { this.close() }
  }
}
